import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { formatPrice } from 'helpers/helpers'
import { FormattedMessage } from 'react-intl'
import { TreatmentVariantProps } from './TreatmentVariant.types'
import {
    StyledCrossedOutPrice,
    VariantWrapper,
} from './TreatmentVariant.styles'

export const TreatmentVariant = ({ data }: TreatmentVariantProps) => {
    const { duration, price, regularPrice, historyLowestPrice } = data

    const shouldDisplayOmnibus =
        regularPrice !== undefined &&
        regularPrice !== null &&
        historyLowestPrice !== undefined &&
        historyLowestPrice !== null

    return (
        <VariantWrapper key={duration} gap={4}>
            {!!duration && (
                <Text variant="body16" color="grayscale_900">
                    {duration} min
                </Text>
            )}
            {price !== undefined && (
                <Box direction="row" align="baseline" gap={8}>
                    <Box gap={4} direction="row" align="baseline">
                        <Text variant="heading4" color="secondary_500">
                            {formatPrice(price)}
                        </Text>
                        <Text
                            variant="bodyExtraSmallStrong"
                            color="secondary_500"
                        >
                            PLN
                        </Text>
                    </Box>
                    {regularPrice !== undefined && regularPrice !== null && (
                        <StyledCrossedOutPrice
                            direction="row"
                            gap={4}
                            align="baseline"
                        >
                            <Text variant="body14" color="grayscale_800">
                                {formatPrice(regularPrice)}
                            </Text>
                            <Text
                                variant="bodyExtraSmall"
                                color="grayscale_800"
                                as="span"
                            >
                                PLN
                            </Text>
                        </StyledCrossedOutPrice>
                    )}
                </Box>
            )}
            {/* 'omnibus' legend, displays:
                    - regular, minimum price
                    - historical, minimum price of 30-day period
                    ! is visible only if:
                    - corresponding values are given from api
                */}
            {shouldDisplayOmnibus && (
                <Box
                    direction="column"
                    gap={4}
                    align="flex-start"
                    mt={12}
                    isFullWidth
                >
                    <Text variant="bodyExtraSmall" color="grayscale_800">
                        <FormattedMessage
                            id="global.discount.regular_price"
                            defaultMessage="_"
                            values={{
                                price: formatPrice(regularPrice),
                            }}
                        />
                    </Text>
                    <Text variant="bodyExtraSmall" color="grayscale_800">
                        <FormattedMessage
                            id="global.discount.lowest_price_30_days"
                            defaultMessage="_"
                            values={{
                                price: formatPrice(historyLowestPrice),
                            }}
                        />
                    </Text>
                </Box>
            )}
        </VariantWrapper>
    )
}

TreatmentVariant.displayName = 'TreatmentVariant'
